import { render, staticRenderFns } from "./TaskDetailsInfo.vue?vue&type=template&id=26b41978"
import script from "./TaskDetailsInfo.vue?vue&type=script&lang=ts"
export * from "./TaskDetailsInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports